import React from 'react';

import CopyableText from '@fmbt/ui/CopyableText';
import User from 'types/models/user';

function ContactSummary({ contact }: { contact: Partial<User> | undefined }) {
  return (
    <div>
      <div className="body-copy">
        {contact?.firstName}
        {contact?.lastName ? ` ${contact?.lastName}` : ''}
      </div>
      {typeof contact?.mobileNumberFormatted === 'string' && (
        <div className="body-copy">{contact.mobileNumberFormatted}</div>
      )}
      {typeof contact?.landlineNumberFormatted === 'string' && (
        <div className="body-copy">{contact.landlineNumberFormatted}</div>
      )}
      {typeof contact?.email === 'string' && (
        <CopyableText>{contact.email}</CopyableText>
      )}
    </div>
  );
}

export default ContactSummary;
